export default [
    {
        path: 'relatorio-acesso-sistema',
        component: () => import(
            /* webpackChunkName: 'administracao-relatorio-acesso-sistema' */
            '@/views/administracao/relatorio-acesso-sistema/Index'
        ),
        redirect: 'relatorio-acesso-sistema/index',
        children: [
            {
                name: 'administracao-relatorio-acesso-sistema-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'administracao-relatorio-acesso-sistema' */
                    '@/views/administracao/relatorio-acesso-sistema/List.vue'
                ),
            },
        ],
    },
]